import React, { Component } from 'react'

import './switcherStyles.scss'
import Icon from '../Icon'

class Switcher extends Component {

  onKeyDown = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      this.props.onChange()
    }
  }

  render () {
    const { onChange, checked, disabled } = this.props

    return (
      <div
        onClick={onChange}
        onKeyDown={this.onKeyDown}
        tabIndex='0'
        data-test='switcher-test-id'
        className={`wrg-toggle ${checked ? 'wrg-toggle--checked' : ''} ${disabled ? 'disabled' : ''}`}
      >
        <div className="wrg-toggle-container">
          <div className="wrg-toggle-check">
            <Icon
              name="tick.svg"
              width="20px"
              height="20px"
              classes="tick-icon"
            />
          </div>
        </div>
        <div className="wrg-toggle-circle" />
        <input className="wrg-toggle-input" type="checkbox" aria-label="Toggle Button" />
      </div>
    )
  }
}

export default Switcher
